import React, { useEffect } from 'react';
import styles from './AppLayout.module.scss';
// import io from 'socket.io-client';
// import { device_URI } from '../../constants/defaultValues';
// import useComponentVisible from '../../../hooks/useComponentVisible';
import Header from '../../Header/Header';
// import Modal from '../../shared/Modal/Modal';
// import TicketResult from '../../shared/Modal/ModalContent/TicketResult';

const AppLayout = props => {
    // const [ticketResult, setTicketResult] = useState(null);
    // const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false);

    useEffect(() => {
        // const socket = io(device_URI);
        // socket.on('ticketCode', data => {
        //   if (data) {
        //     setTicketResult(data);
        //     setIsComponentVisible(true);
        //   }
        // });
    }, []);

    return (
        <div className={styles.appLayout}>
            {/*{isComponentVisible && (*/}
            {/*    <Modal ref={ref} isVisible={isComponentVisible} width='900px' contentPadding='50px'>*/}
            {/*        <TicketResult closeModal={() => setIsComponentVisible(false)} />*/}
            {/*    </Modal>*/}
            {/*)}*/}
            <Header />
            <div className={styles.content}>
                <div className={styles.container}>{props.children}</div>
            </div>
        </div>
    );
};

export default AppLayout;
